import LayoutHR from "layouts/layout-hr";
import React from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "utils/constants";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import { HR_ASSET_REPORT_PERMISSIONS } from "utils/hrPermissionKeys";
import {
  IconBuilding,
  IconCalendarEvent,
  IconCurrencyDollar,
} from "@tabler/icons-react";

const ReportPage = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Asset Report",
      description: "Asset management and tracking reports",
      icon: IconBuilding,
      path: URLS.v1.HR_REPORT_ASSET,
      color: "success",
      permissions: HR_ASSET_REPORT_PERMISSIONS,
    },
    {
      title: "Attendance Report",
      description: "Employee attendance and presence reports",
      icon: IconCalendarEvent,
      path: URLS.v1.HR_REPORT_ATTENDANCE,
      color: "info",
    },
    {
      title: "Salary Report",
      description: "Salary and payroll reports",
      icon: IconCurrencyDollar,
      path: URLS.v1.HR_REPORT_SALARY,
      color: "warning",
    },
    {
      title: "Finance Report",
      description: "Neraca, laba rugi, dan ringkasan keuangan",
      icon: IconCurrencyDollar,
      path: URLS.v1.HR_REPORT_FINANCE,
      color: "primary",
    },
    // {
    //   title: "Settlement Report",
    //   description: "Transaction settlement rekap reports",
    //   icon: IconBuilding,
    //   path: URLS.v1.HR_REPORT_SETTLEMENT,
    //   color: "secondary",
    // },
  ];

  return (
    <LayoutHR>
      <div className="container-xl">
        {/* Page Header */}
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">HR Reports</h2>
              <div className="text-muted mt-1">
                Generate and view HR reports and analytics
              </div>
            </div>
          </div>
        </div>

        {/* Menu Cards */}
        <div className="row row-deck row-cards">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            const menuCard = (
              <div key={index} className="col-sm-6 col-lg-4 mb-4">
                <div className="card card-hover">
                  <div className="card-body text-center">
                    <div
                      className={`avatar avatar-xl mb-3 bg-${item.color}-lt`}
                    >
                      <IconComponent
                        size={32}
                        className={`text-${item.color}`}
                      />
                    </div>
                    <h3 className="card-title mb-2">{item.title}</h3>
                    <p className="text-muted mb-3">{item.description}</p>
                    <button
                      className={`btn btn-${item.color} w-100`}
                      onClick={() => navigate(item.path)}
                    >
                      View 
                      {/* {item.title} */}
                    </button>
                  </div>
                </div>
              </div>
            );

            if (!item.permissions) return menuCard;

            return (
              <PermissionMiddleware key={index} allowedPermissions={item.permissions}>
                {menuCard}
              </PermissionMiddleware>
            );
          })}
        </div>
      </div>
    </LayoutHR>
  );
};

export default ReportPage;
